import script from "./my.vue?vue&type=script&setup=true&name=My&lang=js"
export * from "./my.vue?vue&type=script&setup=true&name=My&lang=js"

import "./my.vue?vue&type=style&index=0&id=d2afba2e&scoped=true&lang=css"
import "./my.vue?vue&type=style&index=1&id=d2afba2e&scoped=true&lang=css"

import exportComponent from "D:\\Jawsro\\company\\虎鲸\\v3\\hujing_pro_h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d2afba2e"]])

export default __exports__